import { IcFocus } from '@assets/icons/24x24';
import { Icon, IconButton } from '@chakra-ui/react';
import { useFormMapContext } from '@components/ui/map/formMap/FormMapContext';

export const PositionPickerList = () => {
  const { isSelectionEnabled, setSelectionOn } = useFormMapContext();

  return (
    <IconButton
      variant="pick"
      aria-label="positionPicker"
      data-active={isSelectionEnabled}
      onClick={() => setSelectionOn(!isSelectionEnabled)}
    >
      <Icon as={IcFocus} boxSize="24px" />
    </IconButton>
  );
};
